<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      <span ref="topAnchor">
        {{ title }}
      </span>
    </template>

    <FormWrapper grid>
      <form @submit.prevent="submit">
        <div class="section">
          <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4 sm:col-span-6">
            Vehicle Options <span class="text-sm text-gray-700">({{ vehicle.name }})</span>
          </h3>

          <FormSelect v-for="item in vehicleOptions"
                      :name="`option_${item.id}`"
                      :label="item.name.toUpperCase()"
                      v-model="form.options[item.id]"
                      :erros="errors"
                      :options="item.values"
                      :disabled="item.values.length == 1"
                      class="col-span-3"
                      full-width
                      />
        </div>
        <div class="section">
          <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4 sm:col-span-6">
            Part <span class="text-sm text-gray-700">({{ part.sku }})</span>
          </h3>

          <FormSelect v-for="item in partOptions"
                      :name="`option_${item.id}`"
                      :label="item.name.toUpperCase()"
                      v-model="form.options[item.id]"
                      :erros="errors"
                      :options="item.values"
                      :disabled="item.values.length == 1"
                      class="col-span-3"
                      full-width
                      />
        </div>

        <div class="section">
          <FormInput name="name"
                     v-model="form.name"
                     :errors="errors"
                     class="sm:col-span-6"/>

          <FormInput name="tax_code"
                     v-model="form.tax_code"
                     :errors="errors"
                     class="sm:col-span-2"/>

          <FormInput name="hs" v-model="form.hs" :errors="errors" class="sm:col-span-2"/>

          <FormInput name="barcode" v-model="form.barcode" :errors="errors" class="sm:col-span-2"/>

          <div class="col-span-4"></div>

          <FormCheckbox v-model="form.active"
                        name="active"
                        class="col-span-4"
                        :errors="errors" />

          <FormCheckbox v-model="form.status.out_of_stock"
                        name="status[out_of_stock]"
                        class="col-span-4"
                        :errors="errors" />

          <FormCheckbox v-model="form.status.in_stock"
                        name="status[in_stock]"
                        class="col-span-4"
                        :errors="errors" />

          <FormCheckbox v-model="form.status.made_to_order"
                        name="status[made_to_order]"
                        class="col-span-4"
                        :errors="errors" />

        </div>

        <div class="section">
          <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4 sm:col-span-6">
            Options
          </h3>

          <FormSelect v-for="item in options"
                      :name="`option_${item.id}`"
                      :label="item.name.toUpperCase()"
                      v-model="form.options[item.id]"
                      :erros="errors"
                      :options="item.values"
                      class="col-span-2"
                      full-width
                      />
        </div>

        <FormActions :cancelUrl="$route('builds.index')"
                     :show-submit="$can('builds.write')"
                     grid />
      </form>
    </FormWrapper>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import { Inertia } from '@inertiajs/inertia'
import Placeholder from './placeholder.vue'
import Alert from '@/components/alert.vue'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  components: {
    Placeholder,
    Alert,
  },

  props: {
    model: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: Object,
    options: Array,
    vehicle: Object,
    vehicleOptions: Array,
    part: Object,
    partOptions: Array,
  },

  data() {
    return {
      title: `Builds :: ${this.model?.external_id}`,
      formSuccess: false,
      form: {
        active: this.model?.active || false,
        status: {
          out_of_stock: this.model?.status?.includes('OOS') || false,
          in_stock: this.model?.status?.includes('IS') || false,
          made_to_order: this.model?.status?.includes('MTO') || false,
        },
        name: this.model?.name || '',
        tax_code: this.model?.tax_code || '',
        hs: this.model?.hs || '',
        barcode: this.model?.barcode || '',
        options: this.options.concat(this.vehicleOptions)
          .concat(this.partOptions)
          .reduce(
            (carry, item) => ({
              ...carry,
              [item.id]: item.selected?.value_id,
            }),
            {}
          ),
      },
    }
  },

  methods: {
    submit() {
      Inertia.put(this.$route('builds.update', [this.model.id]), this.getSubmitData(), {
        onFinish: () => {
          this.$refs.topAnchor.scrollIntoView()
        },
        onSuccess: () => {
          this.formSuccess = true
        },
      })
    },

    getSubmitData() {
      return {
        ...this.form,
      }
    },
  },
}
</script>
